import actionCreatorFactory from 'typescript-fsa'

import {
  GetFacebookFeedForPageRequest,
} from '@3m5/sm_publish-frontend-api/apis/FacebookPostApi'

import { GetFacebookFeedResponse } from '@3m5/sm_publish-frontend-api/models'

const actionCreator = actionCreatorFactory('LOGIN')

/*
 * Actions
 */
export const getFacebookFeedForPageInitiated = actionCreator<GetFacebookFeedForPageRequest>('GET_FACEBOOK_FEED_FOR_PAGE_INITIATED')
export const getFacebookFeedForPage = actionCreator.async<GetFacebookFeedForPageRequest, GetFacebookFeedResponse>('GET_FACEBOOK_FEED_FOR_PAGE')
